import Modal from "react-responsive-modal";
import AudioListItem from "./AudioListItem";
import VideoListItem from "./VideoListItem";
import DocumentListItem from "./DocumentListItem";
import VideoDetails from "../VideoDetails";
import AudioPlayer from "components/AudioPlayer";
import VideoPlayer from "components/VideoPlayer";
import { useState } from "react";

const ListItem = ({
  item,
  allowActions,
  showAction,
  activeTab,
  iDx,
  showDefaultAvatar,
  setReload,
  onUpdate,
}) => {
  const [videoUrl, setVideoUrl] = useState("");
  const [videoDetails, setVideoDetails] = useState({
    title: "",
    description: "",
  });

  return (
    <div style={{ height: "100%" }}>
      {/* video list item */}
      {item.media_type_id === 3 && (
        <VideoListItem
          v={item}
          allowActions={allowActions}
          showAction={showAction}
          showDefaultAvatar={showDefaultAvatar}
          iDx={iDx}
          setVideoUrl={setVideoUrl}
          setVideoDetails={setVideoDetails}
          setReload={setReload}
        />
      )}
      {/* audio list item */}
      {item.media_type_id === 4 && (
        <AudioListItem
          v={item}
          allowActions={allowActions}
          showAction={showAction}
          showDefaultAvatar={showDefaultAvatar}
          iDx={iDx}
          setVideoUrl={setVideoUrl}
          setVideoDetails={setVideoDetails}
          setReload={setReload}
        />
      )}
      {/* document list item */}
      {(item.media_type_id === 5 || activeTab === 3 || item.link) && (
        <DocumentListItem
          v={item}
          allowActions={allowActions}
          showAction={showAction}
          showDefaultAvatar={showDefaultAvatar}
          iDx={iDx}
          setReload={setReload}
          onUpdate={onUpdate}
        />
      )}

      {videoUrl && (
        <Modal
          open
          onClose={() => setVideoUrl("")}
          classNames={{
            modalContainer: "modalContainer",
            modal: "motivationalVideoModalContainer",
          }}
        >
          {videoDetails.title && videoDetails.description && (
            <VideoDetails
              title={videoDetails.title}
              description={videoDetails.title}
            />
          )}
          {item.media_type_id === 3 && <VideoPlayer src={videoUrl} />}
          {item.media_type_id === 4 && <AudioPlayer src={videoUrl} />}
        </Modal>
      )}
    </div>
  );
};

export default ListItem;
